// src/app/layout/main-layout/layout.component.ts
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { FooterComponent } from '../footer/footer.component';
import { LayoutService } from '../layout.service';
import { WorkSessionStateService } from '../../core/services/api/work-session-state.service';
import { WorkSessionGateComponent } from '../../shared/components/work-session-gate/work-session-gate.component';

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [RouterOutlet, SidebarComponent, TopbarComponent, FooterComponent, Toast, WorkSessionGateComponent],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent {
    layout = inject(LayoutService);

    constructor() {
        // Carga el estado de la jornada diaria (herramientas) al entrar a la app
        inject(WorkSessionStateService).init();
    }
}
